import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"padding":"0 30px"} }
const _hoisted_2 = {
  class: "flex",
  style: {"justify-content":"flex-end","margin-bottom":"10px"}
}
const _hoisted_3 = { class: "spaceAroundBtn" }
const _hoisted_4 = { class: "serialNumber" }
const _hoisted_5 = ["title"]
const _hoisted_6 = ["title"]
const _hoisted_7 = ["title"]
const _hoisted_8 = ["title"]
const _hoisted_9 = ["title"]
const _hoisted_10 = ["title"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { style: {"align-items":"center"} }
const _hoisted_13 = {
  key: 0,
  style: {"color":"#e2e2e2","margin":"0 10px"}
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = ["title"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "删除", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlusOutlined = _resolveComponent("PlusOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isEdit)
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            type: "primary",
            ghost: "",
            onClick: _ctx.add,
            style: {"position":"relative","top":"-5px"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_PlusOutlined),
                _createTextVNode(" 选择客户")
              ])
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_a_table, {
      rowKey: "terminalCode",
      columns: _ctx.columns,
      "data-source": _ctx.dataPage,
      pagination: false,
      scroll: _ctx.scroll,
      loading: _ctx.loading,
      size: "small"
    }, {
      serialNumber: _withCtx(({ index }) => [
        _createElementVNode("span", _hoisted_4, _toDisplayString(index + 1), 1)
      ]),
      terminalName: _withCtx(({ record }) => [
        _createElementVNode("div", {
          class: "over_ellipsis",
          title: record.terminalName
        }, _toDisplayString(record.terminalName), 9, _hoisted_5),
        _createElementVNode("div", {
          class: "over_ellipsis",
          title: record.terminalCode
        }, _toDisplayString(record.terminalCode), 9, _hoisted_6)
      ]),
      channelName: _withCtx(({ record }) => [
        _createElementVNode("span", {
          title: record.channelName
        }, _toDisplayString(record.channelName || "--"), 9, _hoisted_7)
      ]),
      activity: _withCtx(({ record }) => [
        _createElementVNode("span", {
          title: record.activity
        }, _toDisplayString(record.activity || "--"), 9, _hoisted_8)
      ]),
      person: _withCtx(({ record }) => [
        _createElementVNode("span", {
          title: record.person && record.person.map((el) => el.name).join(' ')
        }, _toDisplayString(record.person && record.person.map((el) => el.name).join(" ")), 9, _hoisted_9)
      ]),
      cusLabels: _withCtx(({ record }) => [
        _createElementVNode("div", {
          title: record.cusLabels ? record.cusLabels.replace(',', ' | ') : '',
          class: "over_ellipsis"
        }, [
          (record.cusLabels)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.cusLabels.split(','), (el, index) => {
                    return (_openBlock(), _createElementBlock("span", { key: index }, [
                      index
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, "|"))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, _toDisplayString(el), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_14, "--"))
        ], 8, _hoisted_10)
      ]),
      address: _withCtx(({ record }) => [
        _createElementVNode("div", {
          class: "over_ellipsis",
          title: record.address
        }, _toDisplayString(record.address), 9, _hoisted_15)
      ]),
      handle: _withCtx(({ record }) => [
        (_ctx.isEdit)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              type: "link",
              onClick: ($event: any) => (_ctx.del(record)),
              style: {"padding":"0"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DeleteOutlined),
                _hoisted_16
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["columns", "data-source", "scroll", "loading"]),
    _createVNode(_component_Pagination, {
      total: _ctx.total,
      onChangePagination: _ctx.changePagination,
      cache: false,
      ref: "Pagination"
    }, null, 8, ["total", "onChangePagination"]),
    _createVNode(_component_Modal, {
      ref: "Modal",
      selected: _ctx.dataSelected,
      "onUpdate:selected": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dataSelected) = $event)),
      onSub: _ctx.subModal,
      isEdit: _ctx.isEdit
    }, null, 8, ["selected", "onSub", "isEdit"])
  ]))
}